<template class="template-public-part">
    <div class="public-part">
        <div class="content">
            <div class="left-nav">
                <ul>
                    <li :class="{'active':currentNav=='today'}" @click="navJump('today')">
                        <router-link :to="{path:'/Statistics/StatisticsToday'}">
                            <img :class="{'active':currentNav=='today'}" style="width:22px" src="../../assets/img/today.svg" alt="">
                            <div>今日统计</div>
                        </router-link>
                    </li>
                    <li :class="{'active':currentNav=='history'}" @click="navJump('history')">
                        <router-link :to="{path:'/Statistics/HistoricalReport'}">
                            <img :class="{'active':currentNav=='history'}" style="width:26px" src="../../assets/img/history.svg" alt="">
                            <div>历史报表</div>
                        </router-link>
                    </li> 
                    <li :class="{'active':currentNav=='listen'}" @click="navJump('listen')">
                        <router-link :to="{path:'/Statistics/PathListen'}">
                            <img :class="{'active':currentNav=='listen'}" style="width:26px" src="../../assets/img/path-monitor.svg" alt="">
                            <div>通道监听</div>
                        </router-link>
                    </li> 
                </ul>
            </div>
            <div class="right-content">
                <router-view></router-view>
            </div>
        </div>
        <router-link v-if="currentNav!='listen'" target="_blank" rel="opener" class="dialogBox" to="/Communication">
           <a-icon style="z-index:1000;font-size:25px" type="message" />
        </router-link>
    </div>
</template>
<script>
export default {
    name: 'Statistics',
    props: {
        msg: String
    },
    data() {
        return {
            currentNav: 'today',
        };
    },
    methods: {
        navJump(type){
            this.currentNav = type
            sessionStorage.setItem('currentNav',type)
        },
    },
    mounted: function() {
        this.currentNav = (sessionStorage.getItem('currentNav')=='undefined'?'today':sessionStorage.getItem('currentNav'))
    }
}
</script>
<style scoped  lang="less">
    .public-part{
        height: 100%;
        .head{
            background: #fff;
            z-index: 100;
            height: 48px;
            position: fixed;
            top: 0px;
            width: 100%;
            font-size: 14px;
            box-shadow: 3px -1px 9px 2px;
            color: rgba(80, 80, 80, 1);
            text-align: center;
            .left{
                float: left;
            }
            .back{
                margin: 10px 18px 0;
                font-size: 25px;
                color:rgba(19, 194, 194, 1)
            }
            .title{
                font-size: 14px;
                color: rgba(80, 80, 80, 1);
                line-height: 48px;
                font-size: 16px;
                font-weight: bold;
            }
            .head-nav{
                display:inline-block;
                span{
                    margin: 0 5px;
                    line-height: 48px;
                }
            }
            a{
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
            }
        }
        .content{
            // padding-top: 48px;
            height: 100%;
            .left-nav{
                position: fixed;
                height: 100%;
                width: 64px;
                background: rgba(34, 215, 187, 1);
                color: #fff;
                text-align: center;
                // padding-top: 30px;
                li{
                    display: inline-block;
                    width: 100%;
                    height:64px;
                    img{
                        display: block;
                        transition: all  0.25s  ease-in;
                        margin: 22px auto 0;
                    }
                    div{
                        font-size: 12px;
                        display: none;
                        transition: all  0.5s  ease-in;
                    }
                    a{
                        color: #fff;
                        font-size: 24px;
                        height: 64px;
                        display: inline-block;
                        width: 100%;
                    }
                }
                li.active{
                    background: rgba(0, 183, 154, 1);
                }
                li:hover{
                    div{
                        display: block;
                        transform:translateY(-4px);
                    }
                    img{
                        transform:translateY(-10px);
                    }
                }
            }
            .right-content{
                width: 100%;
                padding-left: 64px;
                height: 100%;
                // box-shadow: 0px 0px 1px #000 !important;
            }
        }
    }
</style>
